module.exports = __webpack_public_path__ + "img/service_credit_pc.e6d32300.svg";